import React, { Component } from "react"

import PropTypes from 'prop-types'
import "./notification.css"

/**
 * Banner component
 * @author [Jose Antonio Ciccio](https://github.com/jciccio)
 */

class Notification extends Component {
  constructor(props) {
    super(props)
    this.state = {
      visibleTime: 0,
      show: undefined,
    }

    this.closeBanner = this.closeBanner.bind(this)
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.visibleTime !== undefined && nextProps.visibleTime > 0) {
      let newState = {
        bannerMessage: nextProps.bannerMessage,
        visibleTime: nextProps.visibleTime,
      }
      return newState
    }
    return null
  }

  render() {
    let appearTime = this.props.transitionAppearTime ? this.props.transitionAppearTime : 1000
    let transitionTime = this.props.transitionTime ? this.props.transitionTime : 1000
    return (
      this.renderBanner()
    )
  }

  async hideBanner() {
    if (this.props.visibleTime !== undefined && this.props.visibleTime > 0) {
      await this.timeout(1000 + this.props.visibleTime)
      await this.setState({ show: false })
    }
  }

  closeBanner() {
    this.setState({ show: false })
  }

  renderBanner() {
    let showBanner = this.props.showBanner !== undefined ? this.props.showBanner : true
    if (showBanner) {
      if (this.props.title && (this.state.show === undefined || this.state.show)) {
        { this.hideBanner() }
        return (
          <div key="banner" className="info-notice info-notice__top light-text" style={this.props.css}>
            <div className="container">
              <div className="info-notice-wrapper">
                {this.renderTitle()}
              </div>
            </div>
          </div>
        )
      } else if (this.props.children) {
        return (
          <div key="banner" className="banner" style={this.props.css}>
            {this.props.children}
          </div>
        )
      } else {
        return null
      }
    }
    return null
  }

  renderTitle() {
    let retval = (
      <div className="info-notice-content">
        <button id="closeBanner" className="info-notice-close js-info-notice-close icon-close" onClick={this.closeBanner}>X</button>
        <p>{this.props.title}</p>
      </div>
    )

    if (this.props.href && this.props.cta) {
      let cta = this.buildCTA()
      retval = (
        <div className="info-notice-content">
          <button id="closeBanner" className="info-notice-close js-info-notice-close icon-close" onClick={this.closeBanner}>X</button>
          <p>{this.props.title}</p>
          {' '}
          {cta}
        </div>
      )
    }

    return retval
  }

  buildCTA() {
    return <a href={this.props.href} target="_blank" rel="noreferrer" className="info-notice-link">{this.props.cta}</a>
  }

  timeout(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms))
  }
}

Notification.propTypes = {
  title: PropTypes.node,
  href: PropTypes.string,
  cta: PropTypes.string,
  css: PropTypes.object,
  visibleTime: PropTypes.number,
  image: PropTypes.string,
  imageClass: PropTypes.string,
  transitionAppearTime: PropTypes.number,
  transitionTime: PropTypes.number,
  showBanner: PropTypes.bool,
  children: PropTypes.node,
}

export default Notification
